import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "questionnaire-list" }
const _hoisted_2 = { class: "radio" }
const _hoisted_3 = ["id", "name", "value"]
const _hoisted_4 = ["for"]

import {ref, watch} from "vue";
import {QuestionEntry, RawAnswer} from "@/lib/QuestionHandler";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoiceQuestion',
  props: {
    modelValue: {},
    question: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const value = ref<number|null>(null)

watch(value, () => emit("update:modelValue", value.value), { immediate: true })

watch(() => props.question, () => {
  value.value = props.question.selectedAnswers ? props.question.selectedAnswers[0]?.id : null
}, { immediate: true, deep: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answers, (answer) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row-level2",
        key: answer.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: `answer-${answer.id}`,
            name: `choice-${_ctx.question.id}`,
            value: answer.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
          }, null, 8, _hoisted_3), [
            [_vModelRadio, value.value]
          ])
        ]),
        _createElementVNode("label", {
          for: `answer-${answer.id}`
        }, _toDisplayString(answer.description), 9, _hoisted_4)
      ]))
    }), 128))
  ]))
}
}

})